import { Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import Button from '../Button.js';


class Email extends Component {

	cancelEmailChange = () => {
		route('/', true);
	};

	validateForm = (newEmail, confirmEmail) => {
		this.setState({
			errorNewEmail: undefined,
			errorConfirmEmail: undefined
		});
		if (!newEmail) {
			this.setState({ errorNewEmail: 'You must enter your new email.' });
			return false;
		}
		if (!confirmEmail) {
			this.setState({ errorConfirmEmail: 'You must confirm your email.' });
			return false;
		}
		if (newEmail !== confirmEmail) {
			this.setState({ errorConfirmEmail: 'Emails do not match. Please try again.' });
			return false;
		}
		return true;
	}

	createCookie = (name, value, days) => {
		let expires;
		if (days) {
			let date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			expires = '; expires='+date.toGMTString();
		}
		else {
			expires = '';
		}
		document.cookie = name+"="+value+expires+";domain=.hirezstudios.com;path=/";
	}

	eraseCookie = (name) => {
		this.createCookie(name,'',-1);
	}

	logoutUser = () => {
		this.eraseCookie('HZAcctTokenExp');
		this.eraseCookie('HZAcctUsername');
		this.eraseCookie('HZAcctWebToken');
		this.eraseCookie('HZRegion');
		this.eraseCookie('HZAcctID');
		location.reload();
	}

	submitEmailChange = (e) => {
		this.setState({ buttonEmailChange: 'loading' });
		if (this.validateForm(this.state.newEmail, this.state.confirmEmail)) {
			fetch('https://api.hirezstudios.com/acct/changeEmail', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.webToken}", "newEmail": "${this.state.newEmail}", "password": "${this.state.pass}"}`
			}).then((response) => response.json()).then((response) => {
				this.setState({ buttonEmailChange: 'initial' });
				if (response.statusCode === 200) {
					this.props.notification('success', 10000, `You've successfully changed your email. Logging out momentarily`);
					this.setState({
						newEmail: undefined,
						confirmEmail: undefined
					});
					window.setTimeout(function() {
						this.logoutUser();
					}.bind(this), 3000);
				}
				else if (response.statusCode === 400) {
					this.props.notification('fail', 10000, `There is already a record with this email address or your password may be incorrect. Please verify and submit again.`);
				}
				else if (response.statusCode === 401) {
					this.props.notification('warn', 10000, `Please log out of the account dashboard and try again.`);
					window.setTimeout(function() {
						this.logoutUser();
					}.bind(this), 3000);
				}
 				else {
					this.props.notification('fail', 10000, `Something went wrong. Please try again.`);
				}
			});
		}
		else {
			this.setState({ buttonEmailChange: 'initial' });
		}
	}


	constructor(props) {
		super(props);
		this.state = {
			newEmail: undefined,
			confirmEmail: undefined,
			errorNewEmail: undefined,
			errorConfirmEmail: undefined,
			buttonEmailChange: 'initial',
			pass: undefined
		};
	}

	render() {
		const {
			userData,
			t
		} = this.context;
		return (
			<div className="edit-email">
				<h1>{t('Change Email Address')}</h1>
				<form>
					<label for="current-email">{t('Current Email')}</label>
					<p>{userData.accountInfo && userData.accountInfo.contactInfo.email}</p>
					<label for="new-email">{t('New Email')}</label>
					<input
						id="new-email"
						type="email"
						onInput={e => this.setState({ newEmail: e.target.value })}
						value={t(this.state.newEmail)}
					/>
					<div className="error-new-email">
						{t(this.state.errorNewEmail)}
					</div>
					<label for="confirm-email">{t('Confirm Email')}</label>
					<input
						id="confirm-email"
						type="email"
						onInput={e => this.setState({ confirmEmail: e.target.value })}
						value={t(this.state.confirmEmail)}
					/>
					<label for="password">{t('Password')}</label>
					<input
						id="password"
						type="password"
						onInput={e => this.setState({ pass: e.target.value })}
						value={t(this.state.pass)}
					/>
					<div className="error-confirm-email">
						{t(this.state.errorConfirmEmail)}
					</div>
					<div className="buttons">
						<Button
							color="blue"
							copy={t('Change')}
							state={this.state.buttonEmailwordChange}
							onClick={this.submitEmailChange}
						/>
						<Button
							color="white"
							copy={t('Cancel')}
							onClick={this.cancelEmailChange}
						/>
					</div>
				</form>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(Email);



// WEBPACK FOOTER //
// ./components/views/EditEmail.js